import { supabase } from '@/config/supabase'

export interface EmailStats {
  sentToday: number
  sentThisMonth: number
  failedThisMonth: number
  blockedThisMonth: number
  dailyLimit: number
  monthlyLimit: number
  dailyBreakdown: { date: string; count: number }[]
}

const DAILY_LIMIT = 100
const MONTHLY_LIMIT = 3000

export async function fetchEmailStats(): Promise<EmailStats> {
  const now = new Date()
  const todayStart = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()))
  const monthStart = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1))

  const { data: logs, error } = await supabase
    .from('email_log_sanremo')
    .select('status, created_at')
    .gte('created_at', monthStart.toISOString())
    .order('created_at', { ascending: true })

  if (error) {
    console.error('Error fetching email stats:', error)
    throw error
  }

  const entries = logs || []

  const sentToday = entries.filter(
    (e) => e.status === 'sent' && new Date(e.created_at) >= todayStart
  ).length

  const sentThisMonth = entries.filter((e) => e.status === 'sent').length
  const failedThisMonth = entries.filter((e) => e.status === 'failed').length
  const blockedThisMonth = entries.filter((e) => e.status === 'blocked').length

  // Daily breakdown per il mese corrente
  const dailyMap: Record<string, number> = {}
  entries
    .filter((e) => e.status === 'sent')
    .forEach((e) => {
      const day = new Date(e.created_at).toISOString().slice(0, 10)
      dailyMap[day] = (dailyMap[day] || 0) + 1
    })

  const dailyBreakdown: { date: string; count: number }[] = []
  const daysInMonth = now.getUTCDate()
  for (let d = 1; d <= daysInMonth; d++) {
    const dateStr = `${now.getUTCFullYear()}-${String(now.getUTCMonth() + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`
    dailyBreakdown.push({ date: dateStr, count: dailyMap[dateStr] || 0 })
  }

  return {
    sentToday,
    sentThisMonth,
    failedThisMonth,
    blockedThisMonth,
    dailyLimit: DAILY_LIMIT,
    monthlyLimit: MONTHLY_LIMIT,
    dailyBreakdown,
  }
}
